export const firebaseConfig = {
  apiKey: 'AIzaSyCax9HjHBY8TsjBUqw0XOkuDc8lKGAddPs',
  authDomain: 'rollouter-app.firebaseapp.com',
  projectId: 'rollouter-app',
  storageBucket: 'rollouter-app.appspot.com',
  messagingSenderId: '547506589163',
  appId: '1:547506589163:web:901b62dfe7829a416f9dae',
};
